import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'newlineToBr',
    standalone: false,
})
export class NewlineToBrPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(value: string): SafeHtml {
        if (!value) return value;
        const htmlString = value.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
        return this.sanitizer.bypassSecurityTrustHtml(htmlString);
    }
}
